import { render, staticRenderFns } from "./newsView.vue?vue&type=template&id=08914a73&scoped=true"
import script from "./newsView.vue?vue&type=script&lang=js"
export * from "./newsView.vue?vue&type=script&lang=js"
import style0 from "./newsView.vue?vue&type=style&index=0&id=08914a73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08914a73",
  null
  
)

export default component.exports